import { useEffect,useState,useContext } from "react";
import {
    useNavigate  } from "react-router-dom";
  import $ from "jquery";
  import { Card,ListGroup} from 'react-bootstrap';
  import {BsBookmarkStar} from 'react-icons/bs';
  import UserContext  from '../../contexts/UserContext';
  import ProfileCard from "../Profiles/ProfileCard";
  import { FaPhoneAlt } from "react-icons/fa";

  const Home = (props) => {
    const navigate = useNavigate();
    const {user,setUser} = useContext(UserContext);
    const [totalTakhmeen,setTotalTakhmeen] = useState(null); 
    const [date,setDate] = useState([])
    const [days,setDays] = useState([]);
    const [day,setDay] = useState(null);
    const [niyaaz,setNiyaaz] = useState(null);

  async function getDataForUser(){
    await $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+"/getUsersSession",
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
        success : function(response){
        if(response && response.user){
          console.log(response)
            setUser(response.user);
        }else{
          setUser(null)
          navigate("/login");
        }

      },
      error: function(err){
          console.log("error")
          console.log(err)
      }
    })
    }

    async function getData(userId){
        await $.ajax({
          type:"GET",
          url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
          xhrFields: {
              withCredentials: true  // Include cookies
            },
            crossDomain: true, 
           success : function(response){
            if(response && response.user){
              console.log(response)
               setUser(response.user);
            }else{
              navigate("/login",{state:{message:"Please Login !"}})
            }
    
          },
          error: function(err){
              console.log("error")
              console.log(err)
              navigate("/login",{state:{message:"Something went wrong !"}})
          }
      })
      }

      function getMenu(){
        $.ajax({
          type:"GET",
          url:process.env.REACT_APP_API_URL+"/menus/available",
          xhrFields: {
              withCredentials: true  // Include cookies
            },
            crossDomain: true, 
           success : function(response){
            if(response.menus && response.menus.length>0){
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            console.log(tomorrow)
            const menusRecd = response.menus.filter((menu)=>{
              return new Date(menu.date).toDateString() === tomorrow.toDateString()
            })
            if(menusRecd.length>0){
              setDay(menusRecd[0])
            }
          }else{ 
            // navigate("/login");
          }
            
          },
          error: function(err){
              console.log("error")
              console.log(err)
              // navigate("/login")
          }
        })
      }

      function getTodayNiyaaz(){
        $.ajax({
          type:"GET",
          url:process.env.REACT_APP_API_URL+"/todayNiyaz/"+new Date().toDateString(),
          xhrFields: {
              withCredentials: true  // Include cookies
            },
            crossDomain: true, 
           success : function(response){
            if(!response.message){
              setNiyaaz(response[0])
            }
          },
          error: function(err){
              console.log("error")
              console.log(err)
          }
        })
      }

      async function tomorrowMenu(){
        let tomDate = new Date();
        tomDate.setDate(new Date().getDate()+1);
        if(date.indexOf(tomDate.toDateString())-1>=0){
          setDay(days[date.indexOf(tomDate.toDateString())-1])
        }
      }

      function calculateTotalTakhmeen(userData){
        if(totalTakhmeen === null){
            let totalAmount = 0;
            if(userData){
              userData.takhmeen.map((takhmeen)=>{
                  totalAmount = takhmeen.amount + totalAmount;
              })
            }
            setTotalTakhmeen(totalAmount)
        }
        
    }  
      
    useEffect(()=>{
      try{
        if(!user && (typeof localStorage !== 'undefined') && localStorage.getItem('userSession')){
          getData(JSON.parse(localStorage.getItem('userSession')));
          console.log("in 1")
        }else{
          if(!user){
            getDataForUser();
            console.log("in 2")
          }
        }
      }
      catch(e){
        getDataForUser();
        console.log("in 3")
      }
      getMenu();
      console.log(user)
      console.log("in 4")
      if(!(niyaaz && niyaaz.date && niyaaz.date.includes(new Date().toDateString()))){
        getTodayNiyaaz()
      }
    },[])

    useEffect(()=>{  
      tomorrowMenu()
    },[days])

    const NiyaazCard = () => {
      const design = (
        <>
        {
          niyaaz?
          <div className="achievement-card">
            <div className="achievement-icon ms-0 me-2">
              <BsBookmarkStar />
            </div>
            <div className="achievement-details">
              <div className="recipient-name">Aqa Moula(TUS) Ni Khushi aney Tulul Umr ni Niyat si , Today's Niyaaz Khidmat By : </div>
              <div className="achievement-title mt-1">{niyaaz.name}</div>
            </div>
          </div>
          :
          null
        }
        </>
      )
      return design;
    }


    const design = (
        <>
{user? 
<>
<NiyaazCard/>
<ProfileCard user={user}/>
    {user.takhmeen.length>0?
    (<div className="small-cards">
      <div className="card-sm-container">
        <div className="card-content">
          <p> Takhmeen<br/>{user.takhmeen[user.takhmeen.length-1].year}</p>
          <p className="amount">₹{user.takhmeen[user.takhmeen.length-1].amount}</p>
        </div>
      </div>
      {calculateTotalTakhmeen(user)}
      <div className="card-sm-container">
        <div className="card-content">
          <p>Total Hub Due</p>
          <p className="amount">₹{totalTakhmeen - user.hubPaid}</p>
        </div>
      </div>
    </div>):null} 

    <Card className="mb-4 mt-4 mx-3 w-desktop-small mx-lg-auto">
      <Card.Header style={{backgroundColor:'#884A39'}}>Menu For Tomorrow</Card.Header>
      <ListGroup variant="flush">
      {day ? (
        <>
          {/* Show lunch items */}
          {day.lunch?.items?.length > 0 && 
            day.lunch.items.map((item, i) => (
              <ListGroup.Item className="custom-card" key={`lunch-${i}`}>
                {item} - Lunch
              </ListGroup.Item>
            ))
          }
          
          {/* Show dinner items */}
          {day.dinner?.items?.length > 0 && 
            day.dinner.items.map((item, i) => (
              <ListGroup.Item className="custom-card" key={`dinner-${i}`}>
                {item} - Dinner
              </ListGroup.Item>
            ))
          }
          
          {/* Show "No Thaali" only if both lunch and dinner are empty */}
          {(!day.lunch?.items?.length && !day.dinner?.items?.length) && (
            <ListGroup.Item className="custom-card">
              No Thaali {day.items?.[0]?.label?.length > 0 ? '- ' + day.items[0].label.toString() : null}
            </ListGroup.Item>
          )}
        </>
      ) : null}
      </ListGroup>
    </Card>

<div>
    {
      user.sector && user.sector?.masool ?
<Card className="mb-4 mt-4 mx-3 shadow-lg">
  <Card.Header
    className="text-center"
    style={{
      backgroundColor: '#884A39',
      color: 'white',
      borderRadius: '10px 10px 0 0',
    }}
  >
    Mohalla - {user.sector.name}
  </Card.Header>
  <Card.Body
    className="d-flex justify-content-between"
    style={{
      background: 'linear-gradient(to bottom right, #ffffff, #f8d8b1)',
      borderRadius: '0 0 10px 10px',
      fontSize:'0.8rem'
    }}
  >
    {user.sector.masool && (
      <ListGroup
        className="px-2"
        variant="flush"
        style={{ minWidth: '45%', textAlign: 'center' }}
      >
        <Card.Title
          style={{
            color: '#884A39',
            marginBottom: '1rem',
            fontSize:'0.8rem'
          }}
        >
          Masool
        </Card.Title>
        <ListGroup.Item
          className="mb-2"
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            minHeight: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          {user?.sector?.masool?.name}
        </ListGroup.Item>
        {user?.sector?.masool?.phone &&<ListGroup.Item
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <div>
          <FaPhoneAlt className="me-1" /> Contact : {user?.sector?.masool?.phone}
          </div>
        </ListGroup.Item>}
      </ListGroup>
    )}

    {user.sector.masoola && (
      <ListGroup
        className="px-2"
        variant="flush"
        style={{ minWidth: '45%', textAlign: 'center' }}
      >
        <Card.Title
          style={{
            color: '#884A39',
            marginBottom: '1rem',
          }}
        >
          Masoola
        </Card.Title>
        <ListGroup.Item
          className="mb-2"
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            minHeight: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          {user?.sector?.masoola?.name}
        </ListGroup.Item>
        <ListGroup.Item
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <div>
          <FaPhoneAlt className="me-1" />Contact : {user?.sector?.masoola?.phone}
          </div>
        </ListGroup.Item>
      </ListGroup>
    )}
  </Card.Body>
</Card>
      :
      null
    }

{
      user.subSector?
      <Card className="mb-4 mt-4 mx-3 shadow-lg">
  <Card.Header
    className="text-center"
    style={{
      backgroundColor: '#884A39',
      color: 'white',
      borderRadius: '10px 10px 0 0',
      fontSize:'0.8rem!important'
    }}
  >
    Sub Mohalla - {user.subSector.name}
  </Card.Header>
  <Card.Body
    className="d-flex justify-content-between"
    style={{
      background: 'linear-gradient(to bottom right, #ffffff, #f8d8b1)',
      borderRadius: '0 0 10px 10px',
      fontSize:'0.8rem'
    }}
  >
    {user.subSector.masool && (
      <ListGroup
        className="px-2"
        variant="flush"
        style={{ minWidth: '45%', textAlign: 'center' }}
      >
        <Card.Title
          style={{
            color: '#884A39',
            marginBottom: '1rem',
            fontSize:'0.8rem'
          }}
        >
          Male Incharge
        </Card.Title>
        <ListGroup.Item
          className="mb-2"
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            minHeight: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          {user?.subSector?.masool?.name}
        </ListGroup.Item>
        <ListGroup.Item
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <div>
          <FaPhoneAlt className="me-1" /> Contact : {user?.subSector?.masool?.phone}
          </div>
        </ListGroup.Item>
      </ListGroup>
    )}

    {user.subSector.masoola && (
      <ListGroup
        className="px-2"
        variant="flush"
        style={{ minWidth: '45%', textAlign: 'center' }}
      >
        <Card.Title
          style={{
            color: '#884A39',
            marginBottom: '1rem',
            fontSize:'0.4rem'
          }}
        >
          Female Incharge
        </Card.Title>
        <ListGroup.Item
          className="mb-2"
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            minHeight: '60px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          {user?.subSector?.masoola?.name}
        </ListGroup.Item>
        <ListGroup.Item
          style={{
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <div>
          <FaPhoneAlt className="me-1" /> Contact : {user?.subSector?.masoola?.phone}
          </div>
        </ListGroup.Item>
      </ListGroup>
    )}
  </Card.Body>
</Card>
      :
      null
    }
    </div>
</>
    :null}
        </>
    )


    return design;
}

export default Home;